import React, { useContext } from 'react'
import { Box, Image, Flex, Text, Button } from 'theme-ui'
import EventsModal from './EventsModal'
import EventDate from './EventDate'
import EventDays from './EventDays'
import cloudinaryString from '../../../helpers/cloudinaryString'
import { store } from '../../../Context/Store'

export default function EventItem({ event, setEvents, closeModal, state, slug, variantName }) {
  const { dispatch } = useContext(store)

  const {
    _id,
    name,
    starts,
    //  ends,
    //  description,
    imageurl,
    imageBaseUrl,
    imagePrefix
  } = event

  const onClickImageHandler = () => {
    dispatch({
      type: 'OPEN_LIGHTBOX',
      data: {
        uri: cloudinaryString(imageBaseUrl, imagePrefix, 900),
        caption: name
      }
    })
  }

  return (
    <Flex key={_id} variant={`${variantName}.eventItemContainer`} className={`eventItemContainer ${_id}`}>
      <Image
        variant={`${variantName}.eventItemImage`}
        src={cloudinaryString(imageBaseUrl, imagePrefix, 900)}
        className="eventItemImage"
        alt="Event_Image"
        onClick={onClickImageHandler}
      />
      <Flex variant={`${variantName}.eventItemContent`} className="eventItemContent">
        {!event.eventDays && <EventDate date={starts} variantName={variantName} />}

        <Box className="recurringContentContainer">
          <Text variant={`${variantName}.eventItemTitle`} className="eventItemTitle">
            {name}
          </Text>
          {event.eventDays && <EventDays eventDays={event.eventDays} variantName={variantName} />}
        </Box>
      </Flex>
      <Button
        variant={`${variantName}.eventItemBtn`}
        className="eventItemBtn"
        onClick={() => {
          setEvents({ ...state, modalShowing: _id })
        }}
        sx={{ marginTop: 3, cursor: 'pointer' }}
      >
        See More
      </Button>

      <EventsModal
        slug={slug}
        event={event}
        modalShowing={_id === state.modalShowing}
        closeModal={closeModal}
        variantName={variantName}
      />
    </Flex>
  )
}
